import React from "react";
import classNames from "classnames";
import styles from "./Button.module.css";

function Button({ 
  children, 
  styleType = "Primary", 
  size = "Medium", 
  state = "Enabled", 
  width = "Default",
  onClick, 
  disabled 
}) {
  const buttonClasses = classNames(
    styles.button,
    styles[`style-${styleType}`],
    styles[`size-${size}`],
    styles[`state-${state}`],
    styles[`width-${width}`],
    { [styles.disabled]: disabled }
  );

  return (
    <button 
      className={buttonClasses} 
      onClick={onClick} 
      disabled={disabled || state === "Disabled"}
    >
      {children}
    </button>
  );
}

export default Button;